<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card>
      <v-card-title class="redColor text-white">
        <span v-if="edit === true" class="headline">{{
          $t("shipments.form.edit_shipment")
        }}</span>
        <span v-if="edit === false" class="headline">{{
          $t("shipments.form.create_shipment")
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-md>
            <v-row wrap>
              <v-col cols="12" xs="12" md="12" lg="12">
                <v-text-field
                  v-model="shipment.name"
                  :rules="rules.required"
                  :label="$t('shipments.form.name')"
                  color="red-darken-1"
                  variant="solo"
                />
              </v-col>
              <v-col cols="12" xs="12" md="12" lg="12">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template #activator="{ props }">
                    <v-text-field
                      v-bind="props"
                      v-model="formattedShipmentDate"
                      :label="$t('shipments.form.date')"
                      color="red-darken-1"
                      variant="solo"
                      append-inner-icon="mdi-calendar"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formattedShipmentDate"
                    @update:model-value="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                v-if="
                  $store.getters.role === 'LekoAdmin' ||
                  $store.getters.role === 'LekoEmployee' ||
                  $store.getters.role === 'SuperAdmin'
                "
                 cols="12"
                xs="12"
                md="12"
                lg="12"
              >
                <v-select
                  v-model="shipment.institution_id"
                  :rules="rules.required"
                  :items="institutions"
                  :label="$t('shipments.form.select_institution')"
                  color="red-darken-1"
                  item-title="title"
                  item-value="_id"
                />
              </v-col>
              <v-col>
                <v-switch
                  v-model="shipment.default"
                  :label="$t('shipments.form.default_shipment')"
                  color="red-darken-1"
                />
              </v-col>
              <v-col cols="12" xs="12" md="12" lg="12">
                <v-textarea
                  v-model="shipment.description"
                  variant="solo"
                  :label="$t('shipments.form.description')"
                  color="red-darken-1"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="red-darken-1"
          variant="outlined"
          class="white--text"
          @click="close"
        >
          {{ $t("shipments.form.close") }}
        </v-btn>
        <v-btn
          :loading="loading"
          :disabled="!valid"
          color="green-darken-1"
          variant="outlined"
          class="white--text"
          @click="save"
        >
          {{ $t("shipments.form.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";

import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";
import putRequest from "../../api/putRequest";

export default {
  data: () => ({
    dialog: false,
    valid: false,
    loading: false,
    rules: {
      required: [(v) => !!v || "Please fill this field"],
    },
    shipment: {},
    institutions: [],
    edit: null,
    menu: false,
  }),
  computed: {
    currentDate() {
      return new Date().toISOString().split("T")[0];
    },
    formattedShipmentDate: {
      get() {
        if (!this.shipment.date) return "";
        const date = new Date(this.shipment.date);
        // Handle invalid date safety
        if (isNaN(date)) return "";
        return date.toISOString().split("T")[0];
      },
      set(value) {
        // Keep ISO format in your data
        this.shipment.date = value ? new Date(value).toISOString() : null;
      },
    },
  },
  methods: {
    open(edit, shipment) {
      this.edit = edit;
      if (shipment) this.shipment = shipment;
      this.dialog = true;
      if (
        this.$store.getters.role === "LekoAdmin" ||
        this.$store.getters.role === "LekoEmployee" ||
        this.$store.getters.role === "SuperAdmin"
      ) {
        this.getInstitutions();
      }
    },
    close() {
      this.$emit("close");
      this.dialog = false;
      this.loading = false;
      this.shipment = {};
      this.institutions = [];
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (
          this.$store.getters.role === "User" ||
          this.$store.getters.role === "InstitutionManager" ||
          this.$store.getters.role === "InstitutionAdmin" ||
          this.$store.getters.role === "EbayOperator"
        ) {
          this.shipment.institution_id = this.$store.getters.institutionId;
        }

        if (this.edit === true) {
          putRequest("/shipment/", `id=${this.shipment._id}`, this.shipment)
            .then((response) => {
              if (response.status === 200) {
                this.$emit("save", response);
              }
              this.close();
            })
            .catch(() => {
              this.close();
            });
        } else {
          postRequest
            .object("/shipment/", this.shipment)
            .then((response) => {
              if (response.status === 201) {
                this.$emit("save", response);
              }
              this.close();
            })
            .catch(() => {
              this.close();
            });
        }
      }
    },
    getInstitutions() {
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
        })
        .catch(() => {});
    },
  },
};
</script>
